import React from "react";
import Chart from "react-apexcharts";
import functions from "../../util/functions";

const IncomExpenseChart = ({ totalExpenses, totalIncome}) => {

  // Data for the Donut Chart
  const chartOptions = {
    chart: {
      type: "donut",
      dropShadow: {
        enabled: true,
        top: 2,
        left: 2,
        blur: 3,
        color: "#000",
        opacity: 0.1,
      },
    },
    labels: ["Expenses", "Income"],
    colors: ["#ff1752", "#00e396"], // Light red and light green
    legend: {
      show: false, // Hide the legend
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: false,
              label: "",
              fontSize: "14px",
            },
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `UGX ${functions.numberFormat(value)}`,
      },
    },
  };

  const chartSeries = [totalExpenses*1, totalIncome*1]; // Data for the chart

  return (<>
            <div style={{ width: "100%", marginTop: "-12px"}}>
                <Chart options={chartOptions} series={chartSeries} type="donut" height="120" />
            </div>

            <h6 className="font-weight-bold text-primary text-center mt-2">
                Income & Expenses
            </h6>
            <div className="mt-2 w-100">
                <div className="d-flex justify-content-between">
                <span className="text-muted">
                    Total Income:
                </span>
                <span className="text-success">{functions.numberFormat(totalIncome)}</span>
                </div>
                <div className="d-flex justify-content-between mt-2">
                    <span className="text-muted">
                        Total Expenses:
                    </span>
                    <span className="text-danger">{functions.numberFormat(totalExpenses)}</span>
                </div>
              
            </div>
    </>
  );
};

export default IncomExpenseChart;
